<template>
  <div class="wrapper">
    <div class="banner" v-if="liveNostart.share_reservation_img">
      <img :src="liveNostart.share_reservation_img" class="img" />
    </div>
    <!-- 直播信息 -->
    <div class="infor-card container">
      <GoodsInfoTitle :title="liveData.name" />
      <GoodsInfoCellItem name="直播时间：" :text="liveNostart.centralCourseLiveTime" />
      <GoodsInfoCellItem name="主讲老师：" :text="liveAnchorInfo.name" />
    </div>

    <!-- 直播预约 -->
    <div class="booking-card container">
      <div class="title-time">
        <div class="title">
          距离
          <span class="time">{{ liveNostart.centralCourseLiveStartTime }}</span>
          直播还有
        </div>
      </div>

      <!-- 倒计时 -->
      <div class="timer">
        <div class="timer-item">
          <p class="number">{{ countDownTime.day }}</p>
          <p class="text">天</p>
          <i class="line">/</i>
        </div>
        <div class="timer-item">
          <p class="number">{{ countDownTime.hour }}</p>
          <p class="text">时</p>
          <i class="line">/</i>
        </div>
        <div class="timer-item">
          <p class="number">{{ countDownTime.minute }}</p>
          <p class="text">分</p>
          <i class="line">/</i>
        </div>
        <div class="timer-item">
          <p class="number">{{ countDownTime.second }}</p>
          <p class="text">秒</p>
        </div>
      </div>

      <van-button
        round
        type="primary"
        :disabled="liveNostart.isReservation"
        class="button"
        @click="toBookingForm"
      >
        {{ liveNostart.isReservation ? '已预约' : '预约观看直播' }}
      </van-button>
      <div class="booking-tips">
        有
        <span class="text">{{ liveNostart.reserveNumber }}人</span>
        已预约
      </div>
    </div>

    <!-- 直播介绍 -->
    <div class="introduce-card" v-if="liveNostart.areaCourseIntroHtml">
      <img src="@/assets/images/live/booking/introduce.png" class="title-img" />
      <div class="content" v-html="bodyInfo(liveNostart.areaCourseIntroHtml)"></div>
    </div>
  </div>
</template>

<script>
import GoodsInfoCellItem from '@/components/GoodsInfo/GoodsInfoCellItem.vue'
import GoodsInfoTitle from '@/components/GoodsInfo/GoodsInfoTitle.vue'
import { formatTime, formatSingleNumber } from '@/utils/date'

export default {
  props: {
    liveData: Object,
  },
  data() {
    return {
      timer: -1, //计时器
      currentTimeStamp: 0, //当前时间戳
    }
  },
  components: { GoodsInfoTitle, GoodsInfoCellItem },
  computed: {
    // 预约相关信息
    liveNostart() {
      return this.liveData.nostart || {}
    },
    // 老师相关信息
    liveAnchorInfo() {
      return this.liveData.anchor_info || {}
    },
    // 倒计时
    countDownTime() {
      let surplusTimeStamp = this.surplusTimeStamp >= 0 ? this.surplusTimeStamp : 0
      const formatTimes = formatTime(surplusTimeStamp)
      const day = formatSingleNumber(formatTimes.day),
        hour = formatSingleNumber(formatTimes.hour),
        minute = formatSingleNumber(formatTimes.minute),
        second = formatSingleNumber(formatTimes.second)
      return {
        day,
        hour,
        minute,
        second,
      }
    },
    // 剩余直播时间
    surplusTimeStamp() {
      const time = this.liveNostart.centralCourseLiveTimeTimeStamp - this.currentTimeStamp
      if (time <= 0) {
        return 0
      }
      return time
    },
    // 解析html字符串中 body内容
    bodyInfo() {
      return (html) => {
        return this.$util.getHtmlStringBodyContent(html)
      }
    },
  },
  methods: {
    toBookingForm() {
      let query = this.routeFixedParam()
      query.course_no = this.liveData.no
      query.video_no = this.liveData.live_info.no
      query.id = this.liveData.id

      this.$router.push({
        path: '/live/booking_form',
        query,
      })
    },
    startTimer() {
      if (this.surplusTimeStamp === 0) {
        return
      }
      this.timer = setInterval(() => {
        this.updateCurrentTimeStamp()
        if (this.surplusTimeStamp <= 0) {
          clearInterval(this.timer)
        }
      }, 1000)
    },
    // 更新当前时间戳
    updateCurrentTimeStamp() {
      this.currentTimeStamp = Date.parse(new Date()) / 1000
      if (this.surplusTimeStamp <= 0) {
        this.$emit('onDownTimeEnd')
      }
    },
  },
  mounted() {
    this.updateCurrentTimeStamp()
    this.startTimer()
  },
  destroyed() {
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .goods-specs-item {
    .name {
      width: 1.87rem !important;
    }
  }
}

.wrapper {
  background-color: #fff;
  min-height: 100vh;
  padding-bottom: 1.3rem;
  box-sizing: border-box;
}

.banner {
  height: 6.67rem;
  overflow: hidden;

  .img {
    display: block;
    width: 100%;
  }
}

.infor-card {
  padding-top: 0.5rem;
  padding-bottom: 0.6rem;
  border-bottom: 0.01rem solid #ebecf0;
}

.booking-card {
  padding-top: 0.85rem;
  padding-bottom: 0.76rem;

  .title-time {
    @include flex_center;
    margin-bottom: 0.43rem;

    .title {
      @include text-decorate(
        url('../../../assets/images/live/booking/title_decorate.png'),
        1.09rem,
        0.21rem
      );
      font-size: 0.37rem;
      color: #3c3d42;

      .time {
        color: #ff6a4d;
      }
    }
  }

  .timer {
    display: flex;
    justify-content: center;
    margin-bottom: 0.85rem;

    &-item {
      min-width: 1.76rem;
      text-align: center;
      position: relative;

      .number {
        font-size: 1.07rem;
        font-family: DIN;
        font-weight: bold;
        line-height: 1.3rem;
        color: #3c3d42;
      }

      .text {
        font-size: 0.29rem;
        line-height: 0.43rem;
        color: #919499;
      }

      .line {
        position: absolute;
        top: 0.5rem;
        right: 0;
        font-size: 0.32rem;
        font-family: DIN;
        font-weight: 500;
        color: #ebecf0;
      }
    }
  }

  .button {
    @include flex_center;
    @include margin_center;
    width: 6.4rem;
    height: 1.33rem;
    background: linear-gradient(133deg, #ff6a4d 0%, #ff4521 100%);
    box-shadow: 0px 8px 16px rgba(255, 106, 77, 0.15);
    border-radius: 0.67rem;
    font-size: 0.48rem;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 0.53rem;
    border-color: #ff6a4d !important;
    box-shadow: 0px 8px 16px rgba(255, 106, 77, 0.15);
  }

  .booking-tips {
    font-size: 0.32rem;
    font-weight: 400;
    color: #3c3d42;
    text-align: center;
    margin-bottom: 1rem;

    .text {
      color: #ff6a4d;
    }
  }
}

.introduce-card {
  border-top: 0.01rem solid rgba($color: #ebecf0, $alpha: 0.6);

  .title-img {
    @include margin-left-right(auto);
    height: 1rem;
    display: block;
    margin-top: -0.5rem;
    margin-bottom: 0.53rem;
  }

  .content {
    margin: 0 0.53rem;
    border-radius: 4px;
    overflow: hidden;

    /deep/ img {
      display: block;
    }
  }
}
</style>
